import styled from 'styled-components';

import { mediaQueries } from '@/shared/constants';

export const Container = styled.div`
  background: ${({ theme }) => theme.tokens.colors.neutral[200]};
  min-height: 100vh;
  padding-top: 2.75rem;
  display: flex;
  flex-direction: column;

  @media ${mediaQueries.mobileOrTablet} {
    padding-top: 2.5rem;
  }
`;

export const Header = styled.div`
  background: ${({ theme }) => theme.tokens.colors.neutral[200]};
  height: 2.75rem;
  width: 100%;
  padding: 0 1.25rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;

  @media ${mediaQueries.mobileOrTablet} {
    height: 2.5rem;
  }
`;

export const Logo = styled.div`
  background: ${({ theme }) => theme.tokens.colors.neutral[280]};
  border-radius: 6px;
  height: 1.75rem;
  width: 2.25rem;
  flex-shrink: 0;
  font-size: 10px;
  color: transparent;

  @media ${mediaQueries.mobileOrTablet} {
    height: 1.5rem;
    width: 2rem;
  }
`;

export const Menu = styled.div`
  display: flex;
  gap: 0.75rem;
  padding: 0 0.75rem;

  @media ${mediaQueries.mobileOrTablet} {
    display: none;
  }
`;

export const MenuItem = styled.div`
  background: ${({ theme }) => theme.tokens.colors.neutral[280]};
  border-radius: 6px;
  height: 1.75rem;
  width: 4.5rem;
`;

export const Avatar = styled.div`
  background: ${({ theme }) => theme.tokens.colors.neutral[280]};
  border-radius: 50%;
  height: 1.75rem;
  width: 1.75rem;
  flex-shrink: 0;

  @media ${mediaQueries.mobileOrTablet} {
    border-radius: 6px;
    height: 1.5rem;
    width: 1.5rem;
  }
`;

export const Content = styled.div`
  flex-grow: 1;
`;

export const Footer = styled.div`
  max-width: 1440px;
  display: flex;
  padding: 1.75rem 3.5rem 2.75rem;

  @media ${mediaQueries.mobileOrTablet} {
    display: block;
    padding: 1.75rem 1.5rem;
  }
`;

export const Info = styled.div`
  width: 15rem;
  margin-right: 7rem;

  @media (max-width: 1441px) {
    width: 12rem;
    margin-right: 5rem;
  }

  @media ${mediaQueries.mobileOrTablet} {
    width: 15.75rem;
    margin-right: 0;
  }

  @media ${mediaQueries.mobile} {
    width: auto;
    margin-right: 0;
  }
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  height: 1.5rem;

  &::after {
    content: '';
    background: ${({ theme }) => theme.tokens.colors.neutral[280]};
    border-radius: 4px;
    height: 0.75rem;
    width: 4rem;
  }
`;

export const Slogan = styled.div`
  background: ${({ theme }) => theme.tokens.colors.neutral[280]};
  border-radius: 4px;
  height: 2rem;
`;

export const Copyright = styled.div`
  background: ${({ theme }) => theme.tokens.colors.neutral[280]};
  border-radius: 4px;
  height: 1.25rem;
  width: 7.5rem;
  margin-top: 0.5rem;
`;

export const LanguageSwitcher = styled.div`
  background: ${({ theme }) => theme.tokens.colors.neutral[280]};
  border-radius: 4px;
  height: 2rem;
  margin-top: 1rem;
`;

export const Sitemap = styled.div`
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  gap: 2rem;
  padding-top: 1.5rem;

  @media ${mediaQueries.mobileOrTablet} {
    display: block;
  }
`;

export const SitemapColumn = styled.div`
  width: calc(25% - 2rem);

  @media ${mediaQueries.mobileOrTablet} {
    width: 100%;

    &:not(:nth-child(-n + 2)) {
      display: none;
    }
  }
`;

export const SitemapTitle = styled.div`
  background: ${({ theme }) => theme.tokens.colors.neutral[280]};
  height: 1.25rem;
  margin-bottom: 0.75rem;
  border-radius: 4px;

  @media ${mediaQueries.mobileOrTablet} {
    display: none;
  }
`;

export const SitemapElement = styled.div`
  background: ${({ theme }) => theme.tokens.colors.neutral[280]};
  margin-bottom: 0.5rem;
  height: 1rem;
  border-radius: 4px;
`;

export const DefaultContent = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  padding: 5rem 1.25rem;

  @media ${mediaQueries.mobileOrTablet} {
    padding: 5rem 1rem;
  }
`;

export const DefaultContentSection = styled.div`
  background: ${({ theme }) => theme.tokens.colors.neutral[280]};
  border-radius: 12px;
  height: 20.25rem;
  width: 18.25rem;

  @media ${mediaQueries.mobileOrTablet} {
    width: 100%;

    &:not(:first-child) {
      display: none;
    }
  }
`;
